import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center fill-height" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center justify-center fill-height"
}
const _hoisted_3 = {
  class: "pa-4 text-body-2",
  style: {"white-space":"pre-wrap","word-break":"break-word"}
}

import { ref, computed, onMounted } from 'vue';
import { useDisplay } from 'vuetify';
import { useAccountStore } from '@/stores/account';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceText',
  props: {
    model: {}
  },
  emits: ["closeDialog"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { width } = useDisplay();
const accountStore = useAccountStore();

const isSmallScreen = computed(() => width.value < 768);
const isAdmin = computed(() => accountStore.account?.userType === 'ADMIN');
const isResourcePublished = computed(() => !props.model || props.model.status === 'PUBLISHED');

const loading = ref(true);
const error = ref(false);
const textContent = ref('');
const csvRows = ref<string[][]>([]);

const isCsv = computed(() => props.model?.mimeType === 'text/csv');

const closeDialog = () => emit('closeDialog');

function parseCsv(text: string): string[][] {
  return text
    .split('\n')
    .filter(line => line.trim().length > 0)
    .map(line => line.split(',').map(cell => cell.trim().replace(/^"|"$/g, '')));
}

onMounted(async () => {
  if (!props.model?.path) {
    error.value = true;
    loading.value = false;
    return;
  }

  try {
    const headers: Record<string, string> = {};
    const accountStore = useAccountStore();
    if (accountStore.logon) {
      const token = localStorage.getItem('accessToken');
      if (token) headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(props.model.path, { headers });
    if (!response.ok) throw new Error('fetch failed');

    const text = await response.text();
    textContent.value = text;
    if (isCsv.value) {
      csvRows.value = parseCsv(text);
    }
  } catch {
    error.value = true;
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      style: {"width":"90vw","height":"90vh"},
      class: "d-flex flex-column"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, {
          color: "primary",
          "max-height": "64"
        }, {
          default: _withCtx(() => [
            (__props.model && !isSmallScreen.value)
              ? (_openBlock(), _createBlock(_component_v_toolbar_title, {
                  key: 0,
                  class: "mx-5 altfont"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.model.name), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_spacer),
            (isAdmin.value && !isResourcePublished.value)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  icon: "",
                  variant: "plain",
                  color: "warning",
                  class: "d-print-none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("mdi-alert-outline", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cortona.ipc.resource-not-published', { status: props.model && props.model.status }),
                    void 0,
                    { "bottom-center": true }
                  ]
                ])
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_btn, {
              icon: "",
              onClick: closeDialog
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-close", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_card_text, { class: "flex-grow-1 overflow-auto pa-0" }, {
          default: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "primary"
                  })
                ]))
              : (error.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    type: "error",
                    class: "ma-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('resource-preview.text.error')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : (isCsv.value && csvRows.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" CSV: render as table "),
                      _createVNode(_component_v_table, {
                        "fixed-header": "",
                        height: "100%"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(csvRows.value[0], (header, i) => {
                                return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(header), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(csvRows.value.slice(1), (row, ri) => {
                              return (_openBlock(), _createElementBlock("tr", { key: ri }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, ci) => {
                                  return (_openBlock(), _createElementBlock("td", { key: ci }, _toDisplayString(cell), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createCommentVNode(" Plain text "),
                      _createElementVNode("pre", _hoisted_3, _toDisplayString(textContent.value), 1 /* TEXT */)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})